<script setup lang="ts">
import { ut_getText } from '@base/utils/utils'

defineProps<{
  isSortView?: boolean
  compactView?: boolean
  showSort?: boolean
  showView?: boolean
  // The price list has no "empty list" (24.09.2026): its content is a project, and a project is
  // deleted in the project management, not emptied here.
  hideEmpty?: boolean
}>()

defineEmits<{
  'update:sort': [boolean]
  'update:view': [boolean]
  'update:emptycart': []
}>()
</script>

<template>
  <div class="flex flex-wrap gap-4">
    <div v-if="!isSortView && showSort">
      <UButton icon="i-wilo-sort-solid-full" variant="ghost" color="tertiary" :label="ut_getText('txt_sort-list')" @click="$emit('update:sort', true)" />
    </div>
    <div v-if="!isSortView && !hideEmpty">
      <UButton icon="i-wilo-trash-solid-full" variant="ghost" color="tertiary" :label="ut_getText('txt_delete-list')" @click="$emit('update:emptycart')" />
    </div>
    <div v-if="isSortView">
      <UButton icon="i-wilo-xmark-solid-full" variant="ghost" color="tertiary" @click="$emit('update:sort', false)" />
    </div>
    <div v-if="!isSortView && compactView !== undefined && showView">
      <CompareTableView :compact-view="compactView" @update:view="$emit('update:view', $event)" />
    </div>
  </div>
</template>
